import { render, staticRenderFns } from "./AdminWasteDisposals.vue?vue&type=template&id=b9fc1ee8&scoped=true&"
import script from "./AdminWasteDisposals.vue?vue&type=script&lang=js&"
export * from "./AdminWasteDisposals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fc1ee8",
  null
  
)

export default component.exports